
export default function Hero() {
  const appStoreUrl = 'https://apps.apple.com/us/app/i-say-i-am/id6762150286';

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background with gradient and organic shapes */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#FFF2E9] via-[#FFFBF0] to-[#FFFDF5]">
        {/* Organic blob shapes */}
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#FFF5F0]/40 rounded-full blur-3xl"></div>
        <div className="absolute bottom-32 right-20 w-[500px] h-[500px] bg-[#FFF2E9]/30 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/3 w-80 h-80 bg-[#E8F4FF]/20 rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text Content */}
          <div className="text-center lg:text-left">
            <div className="inline-block">
              <h1 className="text-6xl lg:text-7xl xl:text-8xl font-bold text-[#2C2C2C] tracking-tight mb-6" style={{ fontFamily: 'Literata, serif' }}>
                I Say I Am
              </h1>
              <div className="w-16 h-0.5 bg-[#FFB8B8] mx-auto lg:mx-0 mb-6"></div>
            </div>
            
            <p className="text-2xl lg:text-3xl text-[#5A5A5A] font-medium mb-4">
              Daily alignment, clarity and inner strength.
            </p>
            
            <p className="text-base lg:text-lg text-[#4A4A4A] leading-relaxed max-w-xl mx-auto lg:mx-0 mb-12">
              I Say I Am is a daily affirmations app for grounded personal growth through guided reflection, gratitude journaling, and audio sessions. Download it for iPhone and Android on the App Store and Google Play.
            </p>

            {/* CTA Buttons */}
            <div id="download" className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8 scroll-mt-28">
              <a
                href={appStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download I Say I Am on the App Store"
                className="px-7 py-4 bg-[#2C2C2C] text-white rounded-full text-base font-semibold hover:bg-[#1a1a1a] transition-all hover:shadow-xl hover:-translate-y-0.5 whitespace-nowrap cursor-pointer text-center"
              >
                Download it on the App Store
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.thinkheartapps.isayiam"
                aria-label="Get I Say I Am on Google Play"
                className="px-7 py-4 border-2 border-[#CCCCCC] text-[#2C2C2C] rounded-full text-base font-semibold hover:border-[#2C2C2C] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer text-center"
              >
                Get it on Google Play
              </a>
            </div>
          </div>

          {/* Right: Hero Image */}
          <div className="hidden lg:flex items-center justify-center">
            <div className="w-full h-[600px] flex items-center justify-center">
              <img 
                src="/isayiam-iphone-mockup.png"
                alt="I Say I Am app shown on an iPhone"
                className="w-full h-full object-contain object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
